import Handlebars from 'Vendor/handlebars/dist/handlebars.js';

class HandleBarUtils {

  equalUtil() {
    Handlebars.registerHelper('equal', function (lvalue, rvalue, options) {
      if (arguments.length < 3)
        throw new Error('Handlebars Helper equal needs 2 parameters');
      if (lvalue != rvalue) {
        return options.inverse(this);
      } else {
        return options.fn(this);
      }
    });
  }

  ifEquals() {
    Handlebars.registerHelper('ifEquals', function (a, b, options) {
      if (a === b) {
        return options.fn(this);
      }

      return options.inverse(this);
    });
  }
}

export default new HandleBarUtils();
